import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/login/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CheckLoginGuard implements CanActivate {
  constructor(private authService:AuthService){

  }
  canActivate(){
    let verify=false;
    if(this.authService.verifyAccess()===true){
      verify=true;
    }
    return verify;
  }
  
}
